export default {"src":"https://cdn.jetlend.ru/_next/static/media/icon--caret--green.a4875fdf.svg","height":6,"width":8,"blurWidth":0,"blurHeight":0};